<!--
 * @Descripttion: 福利详情
 * @Author: liaoyijun
 * @Date: 2021-10-22 14:00:01
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-03 09:58:14
-->
<template>
    <div class="center-context-item">
        <div class="center">
            <div class="center-context-title">
                <span>{{ curDetails.benefitContent }}</span>
            </div>
            <div class="center-context-time">
                <span>发布人：{{ curDetails.authorUnit }}</span>
                <span class="time">发布时间：{{ curDetails.updateDate }}</span>
            </div>
            <div class="editor-content" v-html="curDetails.mainBody"></div>
        </div>
    </div>
</template>

<script>
import { benefitDetail } from "@/api";
export default {
    name: "WelfareDetails",
    data() {
        return {
            curDetails: {},
        };
    },
    mounted() {
        this.benefitDetail();
    },
    activated() {
        this.benefitDetail();
    },
    methods: {
        // 获取福利详情
        async benefitDetail() {
            this.loading = true;
            try {
                const { code, body, message } = await benefitDetail({
                    id: this.$route.query.id,
                });
                if (code === "0000") {
                    this.curDetails = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error("系统错误");
            }
            this.loading = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../style.scss";
</style>
